// extracted by mini-css-extract-plugin
module.exports = {"form_input__label":"Gyms_form_input__label__1xBfA"};